import {
  Injectable,
  inject,
} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {Constants} from '../../../../common/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class CookieCommonService {

  private cookieService = inject(CookieService);

  /**
   * Method: Get value from cookie by name
   * @param name
   */
  getFromCookie(name?: string): string {
    return name ? this.cookieService.get(name) : null;
  }

  /**
   * Method: Add value in cookie
   * @param name
   * @param value
   * @param expiryDates
   */
  saveDataInCookie(name?: string, value?: string, expiryDates?: Date): void {
    if (!name && !value) {
      return;
    }
    if (!this.cookieService.check(name)) {
      this.cookieService.set(name, value, expiryDates, Constants.SLASH);
    }
  }

  /**
   * Method: Delete value from cookie
   * @param name
   */
  deleteDataFromCookie(name?: string): void {
    if (this.cookieService.check(name)) {
      this.cookieService.delete(name, Constants.SLASH);
    }
  }

}
